import { UITypes } from 'nocodb-sdk'

export const COLUMN_HEADER_HEIGHT_IN_PX = 32
export const CELL_BOTTOM_BORDER_IN_PX = 1
export const MAX_SELECTED_ROWS = 100
export const ADD_NEW_COLUMN_WIDTH = 60
export const EDIT_INTERACTABLE = [UITypes.SingleSelect, UITypes.MultiSelect, UITypes.User, UITypes.Links]
export const ROW_META_COLUMN_WIDTH = 80
export const ROW_COLOR_BORDER_WIDTH = 4

export const CHUNK_SIZE = 50

export const GROUP_CHUNK_SIZE = 5
export const GROUP_HEADER_HEIGHT = 48
export const GROUP_EXPANDED_BOTTOM_PADDING = 0
export const GROUP_PADDING = 12

export const AGGREGATION_HEIGHT = 36
